(function YieldMatrixCalculatorOld($, HE)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		HE.onload('/YieldMatrix/old/', function onload()
		{
			$('.calc-ref').on('keyup', function keyup() {
				calculateValuesUpdated();
			});

			calculateValuesUpdated();
		});
	});

	function calculateValuesUpdated()
	{
		var member_margin_pct   = fixFloat($('#member-margin-pct').val()) / 100,
			agent_margin_pct    = fixFloat($('#agent-margin-pct').val()) / 100,
			navitrip_margin_pct = fixFloat($('#navitrip-margin-pct').val()) / 100,
			overhead_pct        = fixFloat($('#overhead-pct').val()) / 100,
			consumer_min_pct    = fixFloat($('#consumer-min-pct').val()) / 100,
			consumer_max_pct    = fixFloat($('#consumer-max-pct').val()) / 100,
			agent_min_pct       = fixFloat($('#agent-min-pct').val()) / 100,
			agent_max_pct       = fixFloat($('#agent-max-pct').val()) / 100,
			provider_ids        = $.parseJSON($('#provider_ids').val()),
			best_rate_id        = null,
			best_rate           = null,
			best_navitrip_id    = null,
			best_navitrip       = null;

		provider_ids.forEach(function iterateProviders(id, key) {
			var retail_price = parseFloat($('.retail-price-' + id).val());

			if (!isNaN(retail_price)) {
				if (best_rate_id === null || retail_price < best_rate) {
					best_rate_id = id;
					best_rate    = retail_price;
				}
			}
		});

		if (best_rate_id === null) {
			return;
		}

		provider_ids.forEach(function iterateProviders(id, key) {
			var retail_price            = fixFloat($('.retail-price-' + id).val()),
			    commission              = fixFloat($('.commission-' + id).val()),
			    discount                = fixFloat($('.discount-' + id).val()),
			    net_rate,
			    gross_margin,
			    estimated_overhead,
			    adjusted_gross_margin,
			    adjusted_room_cost,
			    details,
			    min_savings,
			    max_savings,
			    estimated_savings,
			    estimated_selling_price,
			    revised_overhead,
			    adjusted_net_rate,
			    calc_gross_margin,
			    rev_adjusted_room_cost,
			    savings,
			    selling_price,
			    savings_pct,
			    min_agent_commission,
			    max_agent_commission,
			    agent_commission,
			    agent_commission_pct,
			    navitrip_commission,
			    navitrip_commission_pct,
			    navitrip_overhead,
			    navitrip_overhead_pct,
			    margin_allocated,
			    excess_margin,
			    total_gross_margin,
			    navitrip_total_commission,
			    navitrip_total_commission_pct;

			// -----------

			net_rate = retail_price - commission - discount;

			$('.net-rate-' + id).val(accounting.formatNumber(net_rate, 2, ''));

			// -----------

			$('.best-rate-' + id).html(formatDollars(best_rate));
			$('.best-rate-details-' + id).html('lowest retail price (Provider ' + best_rate_id + ')');

			$('.sum-market-rate-' + id).html(formatDollars(best_rate));

			// -----------

			gross_margin = best_rate - net_rate;

			$('.gross-margin-' + id).html(formatDollars(gross_margin));
			$('.gross-margin-details-' + id).html(formatDollars(best_rate) + ' - ' + formatDollars(net_rate) + ' = ' + formatDollars(gross_margin));

			$('.sum-gross-margin-' + id).html(formatDollars(gross_margin));

			// -----------

			estimated_overhead = (best_rate - (gross_margin * (agent_margin_pct + navitrip_margin_pct))) * overhead_pct;

			$('.estimated-overhead-' + id).html(formatDollars(estimated_overhead));
			$('.estimated-overhead-details-' + id).html('(' + formatDollars(best_rate) + ' - (' + formatDollars(gross_margin) + ' * (' + formatPercent(agent_margin_pct) + ' + ' + formatPercent(navitrip_margin_pct) + '))) * ' + formatPercent(overhead_pct) + ' = ' + formatDollars(estimated_overhead));

			// -----------

			adjusted_gross_margin = gross_margin - estimated_overhead;

			$('.adjusted-gross-margin-' + id).html(formatDollars(adjusted_gross_margin));
			$('.adjusted-gross-margin-details-' + id).html(formatDollars(gross_margin) + ' - ' + formatDollars(estimated_overhead) + ' = ' + formatDollars(adjusted_gross_margin));

			// -----------

			adjusted_room_cost = best_rate - adjusted_gross_margin;

			$('.adjusted-room-cost-' + id).html(formatDollars(adjusted_room_cost));
			$('.adjusted-room-cost-details-' + id).html(formatDollars(best_rate) + ' - ' + formatDollars(adjusted_gross_margin) + ' = ' + formatDollars(adjusted_room_cost));

			// -----------

			estimated_savings = adjusted_gross_margin * member_margin_pct;

			details = formatDollars(adjusted_gross_margin) + ' * ' + formatPercent(member_margin_pct) + ' = ' + formatDollars(estimated_savings);

			if (consumer_min_pct > 0) {
				min_savings = best_rate * consumer_min_pct;

				details += '<br>(Consumer Min) ' + formatDollars(best_rate) + ' * ' + formatPercent(consumer_min_pct) + ' = ' + formatDollars(min_savings);

				if (estimated_savings < min_savings) {
					details += '<br>' + formatDollars(estimated_savings) + ' < ' + formatDollars(min_savings);
					details += '<br>Est. Customer Savings = ' + formatDollars(min_savings);

					estimated_savings = min_savings;
				} else {
					details += '<br>' + formatDollars(estimated_savings) + ' >= ' + formatDollars(min_savings);
					details += '<br>Est. Customer Savings = ' + formatDollars(estimated_savings);
				}
			} else if (consumer_max_pct > 0) {
				max_savings = best_rate * consumer_max_pct;

				details += '<br>(Consumer Max) ' + formatDollars(best_rate) + ' * ' + formatPercent(consumer_max_pct) + ' = ' + formatDollars(max_savings);

				if (estimated_savings > max_savings) {
					details += '<br>' + formatDollars(estimated_savings) + ' > ' + formatDollars(max_savings);
					details += '<br>Est. Customer Savings = ' + formatDollars(max_savings);

					estimated_savings = max_savings;
				} else {
					details += '<br>' + formatDollars(estimated_savings) + ' <= ' + formatDollars(max_savings);
					details += '<br>Est. Customer Savings = ' + formatDollars(estimated_savings);
				}
			}

			$('.estimated-savings-' + id).html(formatDollars(estimated_savings));
			$('.estimated-savings-details-' + id).html(details);

			// -----------

			estimated_selling_price = best_rate - estimated_savings;

			$('.estimated-selling-price-' + id).html(formatDollars(estimated_selling_price));
			$('.estimated-selling-price-details-' + id).html(formatDollars(best_rate) + ' - ' + formatDollars(estimated_savings) + ' = ' + formatDollars(estimated_selling_price));

			// -----------

			revised_overhead = estimated_selling_price * overhead_pct;

			$('.revised-overhead-' + id).html(formatDollars(revised_overhead));
			$('.revised-overhead-details-' + id).html(formatDollars(estimated_selling_price) + ' * ' + formatPercent(overhead_pct) + ' = ' + formatDollars(revised_overhead));

			// -----------

			adjusted_net_rate = net_rate + revised_overhead;

			$('.adjusted-net-rate-' + id).html(formatDollars(adjusted_net_rate));
			$('.adjusted-net-rate-details-' + id).html(formatDollars(net_rate) + ' + ' + formatDollars(revised_overhead) + ' = ' + formatDollars(adjusted_net_rate));

			// -----------

			calc_gross_margin = best_rate - adjusted_net_rate;

			$('.calc-gross-margin-' + id).html(formatDollars(calc_gross_margin));
			$('.calc-gross-margin-details-' + id).html(formatDollars(best_rate) + ' - ' + formatDollars(adjusted_net_rate) + ' = ' + formatDollars(calc_gross_margin));

			// -----------

			rev_adjusted_room_cost = best_rate - calc_gross_margin;

			$('.rev-adjusted-room-cost-' + id).html(formatDollars(rev_adjusted_room_cost));
			$('.rev-adjusted-room-cost-details-' + id).html(formatDollars(best_rate) + ' - ' + formatDollars(calc_gross_margin) + ' = ' + formatDollars(rev_adjusted_room_cost));

			// -----------

			savings = calc_gross_margin * member_margin_pct;

			details = formatDollars(calc_gross_margin) + ' * ' + formatPercent(member_margin_pct) + ' = ' + formatDollars(savings);

			if (consumer_min_pct > 0) {
				min_savings = best_rate * consumer_min_pct;

				details += '<br>(Consumer Min) ' + formatDollars(best_rate) + ' * ' + formatPercent(consumer_min_pct) + ' = ' + formatDollars(min_savings);

				if (savings < min_savings) {
					details += '<br>' + formatDollars(savings) + ' < ' + formatDollars(min_savings);
					details += '<br>Customer Savings = ' + formatDollars(min_savings);

					savings = min_savings;
				} else {
					details += '<br>' + formatDollars(savings) + ' >= ' + formatDollars(min_savings);
					details += '<br>Customer Savings = ' + formatDollars(savings);
				}
			} else if (consumer_max_pct > 0) {
				max_savings = best_rate * consumer_max_pct;

				details += '<br>(Consumer Max) ' + formatDollars(best_rate) + ' * ' + formatPercent(consumer_max_pct) + ' = ' + formatDollars(max_savings);

				if (savings > max_savings) {
					details += '<br>' + formatDollars(savings) + ' > ' + formatDollars(max_savings);
					details += '<br>Customer Savings = ' + formatDollars(max_savings);

					savings = max_savings;
				} else {
					details += '<br>' + formatDollars(savings) + ' <= ' + formatDollars(max_savings);
					details += '<br>Customer Savings = ' + formatDollars(savings);
				}
			}

			$('.savings-' + id).html(formatDollars(savings));
			$('.savings-details-' + id).html(details);

			// -----------

			selling_price = best_rate - savings;

			$('.selling-price-' + id).html(formatDollars(selling_price));
			$('.selling-price-details-' + id).html(formatDollars(best_rate) + ' - ' + formatDollars(savings) + ' = ' + formatDollars(selling_price));

			$('.sum-selling-price-' + id).html(formatDollars(selling_price));

			// -----------

			savings_pct = (savings / best_rate) * 100;

			$('.savings-pct-' + id).html(accounting.formatNumber(savings_pct, 2, '') + '%');
			$('.savings-pct-details-' + id).html('(' + formatDollars(savings) + ' / ' + formatDollars(best_rate) + ') * 100 = ' + accounting.formatNumber(savings_pct, 2, '') + '%');

			$('.sum-savings-' + id).html(formatDollars(savings) + ' / ' + accounting.formatNumber(savings_pct, 2, '') + '%');

			// -----------

			agent_commission = calc_gross_margin * agent_margin_pct;

			details = formatDollars(calc_gross_margin) + ' * ' + formatPercent(agent_margin_pct) + ' = ' + formatDollars(agent_commission);

			if (agent_min_pct > 0) {
				min_agent_commission = best_rate * agent_min_pct;

				details += '<br>(Agent Min) ' + formatDollars(best_rate) + ' * ' + formatPercent(agent_min_pct) + ' = ' + formatDollars(min_agent_commission);

				if (agent_commission < min_agent_commission) {
					details += '<br>' + formatDollars(agent_commission) + ' < ' + formatDollars(min_agent_commission);
					details += '<br>Agent Commission = ' + formatDollars(min_agent_commission);

					agent_commission = min_agent_commission;
				} else {
					details += '<br>' + formatDollars(agent_commission) + ' >= ' + formatDollars(min_agent_commission);
					details += '<br>Agent Commission = ' + formatDollars(agent_commission);
				}
			} else if (agent_max_pct > 0) {
				max_agent_commission = best_rate * agent_max_pct;

				details += '<br>(Agent Max) ' + formatDollars(best_rate) + ' * ' + formatPercent(agent_max_pct) + ' = ' + formatDollars(max_agent_commission);

				if (agent_commission > max_agent_commission) {
					details += '<br>' + formatDollars(agent_commission) + ' > ' + formatDollars(max_agent_commission);
					details += '<br>Agent Commission = ' + formatDollars(max_agent_commission);

					agent_commission = max_agent_commission;
				} else {
					details += '<br>' + formatDollars(agent_commission) + ' <= ' + formatDollars(max_agent_commission);
					details += '<br>Agent Commission = ' + formatDollars(agent_commission);
				}
			}

			$('.agent-commission-' + id).html(formatDollars(agent_commission));
			$('.agent-commission-details-' + id).html(details);

			// -----------

			agent_commission_pct = (agent_commission / best_rate) * 100;

			$('.agent-commission-pct-' + id).html(accounting.formatNumber(agent_commission_pct, 2, '') + '%');
			$('.agent-commission-pct-details-' + id).html('(' + formatDollars(agent_commission) + ' / ' + formatDollars(best_rate) + ') * 100 = ' + accounting.formatNumber(agent_commission_pct, 2, '') + '%');

			$('.sum-agent-commission-' + id).html(formatDollars(agent_commission) + ' / ' + accounting.formatNumber(agent_commission_pct, 2, '') + '%');

			// -----------

			navitrip_commission = calc_gross_margin * navitrip_margin_pct;

			$('.navitrip-commission-' + id).html(formatDollars(navitrip_commission));
			$('.navitrip-commission-details-' + id).html(formatDollars(calc_gross_margin) + ' * ' + formatPercent(navitrip_margin_pct) + ' = ' + formatDollars(navitrip_commission));

			// -----------

			navitrip_commission_pct = (navitrip_commission / best_rate) * 100;

			$('.navitrip-commission-pct-' + id).html(accounting.formatNumber(navitrip_commission_pct, 2, '') + '%');
			$('.navitrip-commission-pct-details-' + id).html('(' + formatDollars(navitrip_commission) + ' / ' + formatDollars(best_rate) + ') * 100 = ' + accounting.formatNumber(navitrip_commission_pct, 2, '') + '%');

			$('.sum-navitrip-commission-' + id).html(formatDollars(navitrip_commission) + ' / ' + accounting.formatNumber(navitrip_commission_pct, 2, '') + '%');

			// -----------

			navitrip_overhead = revised_overhead;

			$('.navitrip-overhead-' + id).html(formatDollars(navitrip_overhead));
			$('.navitrip-overhead-details-' + id).html(formatDollars(estimated_selling_price) + ' * ' + formatPercent(overhead_pct) + ' = ' + formatDollars(navitrip_overhead));

			// -----------

			navitrip_overhead_pct = (navitrip_overhead / selling_price) * 100;

			$('.navitrip-overhead-pct-' + id).html(accounting.formatNumber(navitrip_overhead_pct, 2, '') + '%');
			$('.navitrip-overhead-pct-details-' + id).html('(' + formatDollars(navitrip_overhead) + ' / ' + formatDollars(selling_price) + ') * 100 = ' + accounting.formatNumber(navitrip_overhead_pct, 2, '') + '%');

			$('.sum-payment-overhead-' + id).html(formatDollars(navitrip_overhead) + ' / ' + accounting.formatNumber(navitrip_overhead_pct, 2, '') + '%');

			// -----------

			margin_allocated = savings + agent_commission + navitrip_commission + navitrip_overhead;

			$('.margin-allocated-' + id).html(formatDollars(margin_allocated));
			$('.margin-allocated-details-' + id).html(formatDollars(savings) + ' + ' + formatDollars(agent_commission) + ' + ' + formatDollars(navitrip_commission) + ' + ' + formatDollars(navitrip_overhead) + ' = ' + formatDollars(margin_allocated));

			// -----------

			excess_margin = gross_margin - margin_allocated;

			$('.excess-margin-' + id).html(formatDollars(excess_margin));
			$('.excess-margin-details-' + id).html(formatDollars(gross_margin) + ' - ' + formatDollars(margin_allocated) + ' = ' + formatDollars(excess_margin));

			$('.sum-excess-margin-' + id).html(formatDollars(excess_margin) + ' / ' + accounting.formatNumber(((excess_margin / best_rate) * 100), 2, '') + '%');

			// -----------

			total_gross_margin = margin_allocated + excess_margin;

			$('.total-gross-margin-' + id).html(formatDollars(total_gross_margin));
			$('.total-gross-margin-details-' + id).html(formatDollars(margin_allocated) + ' + ' + formatDollars(excess_margin) + ' = ' + formatDollars(total_gross_margin));

			// -----------

			navitrip_total_commission = navitrip_commission + excess_margin;

			$('.navitrip-total-commission-' + id).html(formatDollars(navitrip_total_commission));
			$('.navitrip-total-commission-details-' + id).html(formatDollars(navitrip_commission) + ' + ' + formatDollars(excess_margin) + ' = ' + formatDollars(navitrip_total_commission));

			navitrip_total_commission_pct = (navitrip_total_commission / best_rate) * 100;

			$('.navitrip-total-commission-pct-' + id).html(accounting.formatNumber(navitrip_total_commission_pct, 2, '') + '%');
			$('.navitrip-total-commission-pct-details-' + id).html('(' + formatDollars(navitrip_total_commission) + ' / ' + formatDollars(best_rate) + ') * 100 = ' + accounting.formatNumber(navitrip_total_commission_pct, 2, '') + '%');

			$('.sum-navitrip-total-commission-' + id).html(formatDollars(navitrip_total_commission) + ' / ' + accounting.formatNumber(navitrip_total_commission_pct, 2, '') + '%');

			// -----------

			if (best_navitrip_id === null || navitrip_total_commission > best_navitrip) {
				best_navitrip_id = id;
				best_navitrip    = navitrip_total_commission;
			}
		});

		provider_ids.forEach(function iterateProviders(id, key) {
			if (id === best_navitrip_id) {
				$('.provider-' + id).addClass('text-danger');
			} else {
				$('.provider-' + id).removeClass('text-danger');
			}
		});

		highlightBest();
	}

	function fixFloat(float)
	{
		var fixed_float = parseFloat(float);

		if (isNaN(fixed_float)) {
			fixed_float = parseFloat(0);
		}

		return fixed_float;
	}

	function formatDollars(dollars)
	{
		var output;

		if (dollars < 0) {
			output = '(' + accounting.formatMoney(Math.abs(dollars)) + ')';
		} else {
			output = accounting.formatMoney(dollars);
		}

		return output;
	}

	function formatPercent(percent)
	{
		var output = accounting.formatNumber(percent, 4).replace(/0+$/, '');

		return output;
	}

	function highlightBest()
	{
		var provider_ids = $.parseJSON($('#provider_ids').val()),
			best;

		provider_ids.forEach(function iterateProviders(id, key) {
			if (best === undefined) {
				best = parseFloat($('.effective-value-' + id).html());
			} else if (parseFloat($('.effective-value-' + id).html()) > best) {
				best = parseFloat($('.effective-value-' + id).html());
			}
		});

		provider_ids.forEach(function iterateProviders(id, key) {
			if (parseFloat($('.effective-value-' + id).html()) === best) {
				$('.effective-value-' + id).addClass('text-danger');
			} else {
				$('.effective-value-' + id).removeClass('text-danger');
			}
		});
	}
}(jQuery, window.HE || {}));